/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import {
  empty,
  prepareResponseData,
  isObject,
  isArray,
  handleFileUpload,
  isString,
  errorResponse,
  intval,
} from "../../Utilities/utils";
import { Toast } from "primereact/toast";

// css
import "../students/Students.css";
import "../dashboard/Dashboard.css";
import "../staff/Staff.css";

// api
import parentApi from "../../api/Parents";
import generalApi from "../../api/General";

// components
import MainHeader from "../../components/headers/mainHeader/MainHeader";
import AppWrapper from "../../components/appWrapper/AppWrapper";
import Card from "../../components/card/Card";
import StatCard from "../../components/statcard/StatCard";
import {
  FaBookReader,
  FaChartArea,
  FaChartLine,
  FaCloudUploadAlt,
  FaImage,
  FaPlus,
  FaQrcode,
  FaStar,
  FaUserEdit,
  FaUserGraduate,
} from "react-icons/fa";
import { useContext } from "react";
import { AuthContext } from "../Root/ProtectedRoute";
import { Avatar } from "primereact/avatar";
import BoxLoading from "../../components/skeleton/BoxLoading";
import ItemLoading from "../../components/skeleton/ItemLoading";
import TableLoading from "../../components/skeleton/TableLoading";
import ButtonIcon from "../../components/buttons/buttonIcon/ButtonIcon";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import FullPageLoader from "../../components/loader/FullPageLoader";
import colors from "../../config/colors";

const ParentProfile = ({ ...props }) => {
  const { user } = useContext(AuthContext);
  const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
  const [assessmentPercentage, setAssessmentPercentage] = useState(0);
  const [percentageLoading, setPercentageLoading] = useState(0);
  const [modalVisible, setModalVisible] = useState(false);
  const [initials, setInitials] = useState("");
  const [qrCodePath, setQRCode] = useState("");
  const [parentKidsStat, setParentKidsStat] = useState({
    noOfCurrentKids: 0,
    noOfGraduatedKids: 0,
    currentKids: [],
    graduatedKids: [],
  });
  const [isUploadAvatarModal, setIsUploadAvatarModal] = useState(false);
  const [previewAvatar, setPreviewAvatar] = useState("");
  const [parentDetails, setParentDetails] = useState({});
  const [avatar, setAvatar] = useState("");

  const fileInputRef = useRef(null);
  const location = useLocation();

  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // (WIP)
  const { parentId } = useParams();
  const toastTR = useRef(null);

  // alert functions
  const responseDialog = (severity = null, summary = null, detail = null) => {
    toastTR?.current?.show({
      severity,
      summary,
      detail,
      life: 8000,
    });
  };

  useEffect(() => {
    if (!parentId) {
      navigate("/404");
    }
    // check if a new parent was added
    if (!empty(location) && !empty(location.state)) {
      const paramState = !empty(location.state) ? location.state : {};
      const parentAdded = !empty(paramState.parentAdded)
        ? paramState.parentAdded
        : false;
      const parentUpdated = !empty(paramState.parentUpdated)
        ? paramState.parentUpdated
        : false;
      if (parentAdded === true || parentUpdated === true) {
        const actionType = parentAdded ? "added" : "updated";
        paramState.parentAdded = false;
        paramState.parentUpdated = false;
        responseDialog(
          "success",
          "Success",
          `Parent ${actionType} successfully!`
        );
        if (!empty(location) && !empty(location.state)) {
          navigate(null, {
            replace: true,
            state: { parentAdded: false, parentUpdated: false },
          });
        }
      }
    }
    getParentDetails();
  }, []);

  useEffect(() => {
    getParentKidsStat();
  }, [parentId, user?._id]);

  /**
   * A method to get parent details
   * @returns
   */
  const getParentDetails = async () => {
    setIsLoading(true);
    try {
      const response = await parentApi.getParentDetails(parentId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }

      if (
        !empty(response_data) &&
        !empty(response_data.response) &&
        isObject(response_data.response)
      ) {
        const userData = response_data.response;

        if (!empty(userData)) {
          setAvatar(!empty(userData.avatar) ? userData.avatar : "");
          const firstNameInitial = !empty(userData.firstName)
            ? userData.firstName.charAt(0)
            : "";
          const lastNameInitial = !empty(userData.lastName)
            ? userData.lastName.charAt(0)
            : "";
          setInitials(`${lastNameInitial}${firstNameInitial}`);
          setParentDetails({
            title: !empty(userData.title) ? userData.title : "",
            _id: !empty(userData._id) ? userData._id : "",
            fullName: !empty(userData.fullName) ? userData.fullName : "",
            firstName: !empty(userData.firstName) ? userData.firstName : "",
            lastName: !empty(userData.lastName) ? userData.lastName : "",
            middleName: !empty(userData.middleName) ? userData.middleName : "",
            regNo: !empty(userData.regNo) ? userData.regNo : "",
            address: !empty(userData.address) ? userData.address : "",
            stateOfResidence: !empty(userData.stateOfResidence)
              ? userData.stateOfResidence
              : "",
            lgaOfResidence: !empty(userData.lgaOfResidence)
              ? userData.lgaOfResidence
              : "",
            stateOfOrigin: !empty(userData.stateOfOrigin)
              ? userData.stateOfOrigin
              : "",
            lgaOfOrigin: !empty(userData.lgaOfOrigin)
              ? userData.lgaOfOrigin
              : "",
            maritalStatus: !empty(userData.maritalStatus)
              ? userData.maritalStatus
              : "",
            religion: !empty(userData.religion) ? userData.religion : "",
            phoneNumber: !empty(userData.phoneNumber)
              ? userData.phoneNumber
              : "",
            email: !empty(userData.email) ? userData.email : "",
          });

          setQRCode(
            !empty(userData.qrCodePath) && isString(userData.qrCodePath)
              ? userData.qrCodePath
              : ""
          );
        }
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * A method to get parent kids stat
   * @returns
   */
  const getParentKidsStat = async () => {
    setIsLoading(true);
    try {
      const response = await parentApi.getParentKidsStat(parentId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Something went wrong"
        );
      }

      if (
        !empty(response_data) &&
        !empty(response_data.response) &&
        isObject(response_data.response)
      ) {
        const parentKidsStat = response_data.response;
        setParentKidsStat(parentKidsStat);
      }
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  // Function to trigger the hidden file input click
  const handleImageFilePickUp = () => {
    fileInputRef.current.click();
  };

  /**
   * submit avatar
   * @returns
   */
  const submitAvatar = async () => {
    // send file to the server
    try {
      if (!isLoading) setIsLoading(true);
      const parentId =
        !empty(parentDetails) && !empty(parentDetails._id)
          ? parentDetails._id
          : "";
      const response = await parentApi.uploadParentAvatar(
        parentId,
        previewAvatar,
        "parents"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to update parent avatar!"
        );
      }

      setAvatar(previewAvatar);

      return responseDialog(
        "success",
        "Success",
        "Parent avatar updated successfully."
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
      setPreviewAvatar("");
      setIsUploadAvatarModal(false);
    }
  };

  /**
   * update qrcode
   * @returns
   */
  const updateQRCode = async () => {
    // send file to the server
    try {
      if (!isLoading) setIsLoading(true);
      const parentId =
        !empty(parentDetails) && !empty(parentDetails._id)
          ? parentDetails._id
          : "";
      const response = await generalApi.updateQRCode(
        parentId,
        schoolId,
        "parents"
      );
      const response_data = prepareResponseData(response);
      if (empty(response_data) || empty(response_data.success)) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data) && !empty(response_data.response)
            ? response_data.response
            : "Failed to update qr-code!"
        );
      }

      let qrCodePath = "";
      if (
        !empty(response_data) &&
        !empty(response_data.response) &&
        !empty(response_data.response.qrCodePath)
      ) {
        qrCodePath = response_data.response.qrCodePath;
      }
      // update qr code
      setQRCode(qrCodePath);

      return responseDialog(
        "success",
        "Success",
        "Update qr-code successfully."
      );
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
    }
  };

  /**
   * function to hide confirm modal
   */
  const hideDeleteModal = () => {
    setModalVisible(false);
  };

  /**
   * Delete Parent
   * @returns
   */
  const deleteParent = async () => {
    setIsLoading(true);
    try {
      const schoolId = !empty(user) && !empty(user._id) ? user._id : "";
      const response = await parentApi.deleteParent(parentId, schoolId);
      const response_data = prepareResponseData(response);
      if (empty(response_data) || !response_data.success) {
        return responseDialog(
          "error",
          "Error Alert",
          !empty(response_data.response)
            ? typeof response_data.response === "string"
              ? response_data.response
              : "Something went wrong!"
            : "Failed to delete parent."
        );
      }

      // redirect to parents list
      const parentDeleted = true;
      navigate("/parents", {
        state: { parentDeleted },
      });
    } catch (error) {
      responseDialog("error", "Error Alert!", errorResponse(error));
    } finally {
      setIsLoading(false);
      return setModalVisible(false);
    }
  };

  const modalFooter = (
    <div
      style={{
        marginTop: 20,
      }}
    >
      <Button
        label="No"
        icon="pi pi-times"
        style={{
          backgroundColor: "transparent",
          color: "#e65061",
          borderColor: "#e65061",
          borderWidth: 1,
        }}
        onClick={hideDeleteModal}
      />
      <Button
        label="Yes"
        icon="pi pi-check"
        style={{
          backgroundColor: "transparent",
          color: "#389d17",
          borderColor: "#389d17",
          borderWidth: 1,
        }}
        onClick={deleteParent}
      />
    </div>
  );

  const updateParentProfile = () => {
    navigate(`/parents/${parentId}/update`);
  };

  return (
    <>
      <AppWrapper {...props}>
        <main>
          {/* menu header */}
          <MainHeader title="Parent Profile" />
          {/* end menu header */}
          <div
            className="mt-10"
            style={{ display: "flex", flexDirection: "row" }}
          >
            {/* left box */}
            <div id="main_left_box">
              {/* stat box */}
              <div className="top_stat_box">
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor="#633ccd"
                        title="No. of Kids"
                        entry={
                          isObject(parentKidsStat) &&
                          !empty(parentKidsStat.noOfCurrentKids) &&
                          intval(parentKidsStat.noOfCurrentKids)
                            ? intval(parentKidsStat.noOfCurrentKids)
                            : 0
                        }
                        icon={<FaUserGraduate className="stat_card_icon" />}
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !isLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor="#633ccd"
                        title="No. of Graduated Kids"
                        entry={
                          isObject(parentKidsStat) &&
                          !empty(parentKidsStat.noOfGraduatedKids) &&
                          intval(parentKidsStat.noOfGraduatedKids)
                            ? intval(parentKidsStat.noOfGraduatedKids)
                            : 0
                        }
                        icon={<FaBookReader className="stat_card_icon" />}
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    !percentageLoading ? (
                      <StatCard
                        underlineWidth={15}
                        bgColor="#633ccd"
                        title="Fees Owed"
                        entry={assessmentPercentage + "%"}
                        icon={<FaChartLine className="stat_card_icon" />}
                      />
                    ) : (
                      <BoxLoading />
                    )
                  }
                  addStyle="card_adjust_stat"
                />
                <Card
                  children={
                    <StatCard
                      underlineWidth={15}
                      bgColor="#633ccd"
                      title="Fees Paid"
                      entry="N/A"
                      icon={<FaChartArea className="stat_card_icon" />}
                    />
                  }
                  addStyle="card_adjust_stat"
                />
              </div>
              {/* stat header end */}

              {/* chart */}
              <div className="chart_box">
                <Card
                  children={
                    <>
                      <MainHeader title="Parent Bio-Data" />
                      <div className="dashboard_school_list">
                        <div className="avatar-container flex">
                          <div className="staff-avatar-container">
                            <p className="fs-20 bold w-100pc">
                              {parentDetails.title} {parentDetails.fullName}
                            </p>
                            {!empty(avatar) ? (
                              <Avatar
                                image={avatar}
                                shape="circle"
                                style={{
                                  width: 200,
                                  height: 200,
                                  padding: 10,
                                  marginLeft: 20,
                                }}
                                className="mb-10"
                              ></Avatar>
                            ) : (
                              <Avatar
                                label={initials}
                                shape="circle"
                                style={{
                                  width: 150,
                                  height: 150,
                                  fontSize: 70,
                                  marginLeft: 20,
                                }}
                              ></Avatar>
                            )}
                            {!parentDetails.graduated && (
                              <div>
                                <ButtonIcon
                                  height={50}
                                  color={colors.primary}
                                  backgroundColor="transparent"
                                  width={180}
                                  fontSize={22}
                                  borderColor="transparent"
                                  buttonText="Update Avatar"
                                  iconMarginRight={8}
                                  icon={<FaCloudUploadAlt />}
                                  fontWeight="bold"
                                  onClick={() => setIsUploadAvatarModal(true)}
                                />
                                <ButtonIcon
                                  height={50}
                                  color={colors.primary}
                                  backgroundColor="transparent"
                                  width={180}
                                  marginTop={-2}
                                  fontSize={22}
                                  borderColor="transparent"
                                  buttonText="Update Profile"
                                  iconMarginRight={8}
                                  icon={<FaUserEdit />}
                                  fontWeight="bold"
                                  onClick={() => updateParentProfile()}
                                />
                              </div>
                            )}
                          </div>

                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Registration Number:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.regNo
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Title: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.title
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">First Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.firstName
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Last Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.lastName
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Middle Name: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.middleName
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Address: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.address
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Marital Status:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.maritalStatus
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="personal-info-block">
                            <div className="personal-info-list">
                              <div className="profile-title">Religion: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.religion
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                Phone Number:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.phoneNumber
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">Email: </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.email
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Origin:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.stateOfOrigin
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Origin:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.lgaOfOrigin
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                State of Residence:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.stateOfResidence
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                            <div className="personal-info-list">
                              <div className="profile-title">
                                L.G.A of Residence:{" "}
                              </div>
                              <div className="profile-value">
                                {!isLoading ? (
                                  parentDetails.lgaOfResidence
                                ) : (
                                  <ItemLoading />
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="other-staff-info-header mb-20">
                          <MainHeader title="Other Information" />
                        </div>
                        <div className="flex sm-reverse-direction-vertical other-staff-info col-g-12">
                          <div className="personal-info-block">
                            <img
                              width={250}
                              height={250}
                              src={qrCodePath}
                              alt="qrcode"
                            />
                            <ButtonIcon
                              height={40}
                              marginTop={1}
                              color={colors.primary}
                              backgroundColor={colors.lightgray}
                              width={180}
                              fontSize={22}
                              borderColor={colors.lightgray}
                              buttonText="Update QR-Code"
                              iconMarginRight={8}
                              marginLeft={4}
                              icon={<FaQrcode />}
                              fontWeight="bold"
                              onClick={() => updateQRCode()}
                            />
                          </div>
                        </div>
                      </div>
                    </>
                  }
                  addStyle="student_list_box"
                />
              </div>
              {/* end chart */}

              {/*  */}
            </div>
            {/* end of left box */}

            {/* right box */}
            <div id="main_right_box">
              <div className="main_right_boxes">
                <Card
                  children={
                    <>
                      <MainHeader
                        title="Active Children/Wards"
                        rightIcon={
                          <NavLink to={`/parent/${parentId}/add-children`}>
                            <FaPlus color={colors.primary} size={18} />
                          </NavLink>
                        }
                      />
                      <div className="mt-10">
                        {!isLoading ? (
                          isObject(parentKidsStat) &&
                          isArray(parentKidsStat.currentKids) ? (
                            parentKidsStat.currentKids.map((item, index) => {
                              const firstName =
                                !empty(item) && !empty(item.firstName)
                                  ? item.firstName
                                  : "";
                              const lastName =
                                !empty(item) && !empty(item.lastName)
                                  ? item.lastName
                                  : "";
                              const middleName =
                                !empty(item) && !empty(item.middleName)
                                  ? item.middleName
                                  : "";
                              const classTitle =
                                !empty(item) && !empty(item.classTitle)
                                  ? item.classTitle
                                  : "";
                              const studentId =
                                !empty(item) && !empty(item._id)
                                  ? item._id
                                  : "";
                              const fullName = `${lastName} ${firstName} ${middleName} - (${classTitle})`;
                              return (
                                <p
                                  key={index}
                                  className="mb-10 flex space-between bio-data-item"
                                >
                                  <NavLink
                                    to={`/student/${studentId}/profile`}
                                    key={studentId}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <FaStar
                                      color="#DAA520"
                                      style={{ marginRight: 8, fontSize: 12 }}
                                    />
                                    <span style={{ color: colors.black }}>
                                      {fullName}
                                    </span>
                                  </NavLink>
                                </p>
                              );
                            })
                          ) : (
                            ""
                          )
                        ) : (
                          <TableLoading rows={5} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  addStyle="card_adjust"
                />

                <Card
                  children={
                    <>
                      <MainHeader title="Graduated Children/Wards" />
                      <div className="mt-10">
                        {!isLoading ? (
                          isObject(parentKidsStat) &&
                          isArray(parentKidsStat.graduatedKids) ? (
                            parentKidsStat.graduatedKids.map((item, index) => {
                              const firstName =
                                !empty(item) && !empty(item.firstName)
                                  ? item.firstName
                                  : "";
                              const studentId =
                                !empty(item) && !empty(item._id)
                                  ? item._id
                                  : "";
                              const lastName =
                                !empty(item) && !empty(item.lastName)
                                  ? item.lastName
                                  : "";
                              const middleName =
                                !empty(item) && !empty(item.middleName)
                                  ? item.middleName
                                  : "";
                              const classTitle =
                                !empty(item) && !empty(item.classTitle)
                                  ? item.classTitle
                                  : "";
                              const fullName = `${lastName} ${firstName} ${middleName} - (${classTitle})`;
                              return (
                                <p
                                  key={index}
                                  className="mb-10 flex space-between bio-data-item"
                                >
                                  <NavLink
                                    to={`/student/${studentId}/profile`}
                                    style={{ textDecoration: "none" }}
                                  >
                                    <FaStar
                                      color="#DAA520"
                                      style={{ marginRight: 8, fontSize: 12 }}
                                    />
                                    <span style={{ color: colors.black }}>
                                      {fullName}
                                    </span>
                                  </NavLink>
                                </p>
                              );
                            })
                          ) : (
                            ""
                          )
                        ) : (
                          <TableLoading rows={5} cols={1} header={false} />
                        )}
                      </div>
                    </>
                  }
                  addStyle="card_adjust"
                />
              </div>
            </div>
            {/* end of right box */}
          </div>
        </main>
        <Toast ref={toastTR} position="bottom-left" />
        {isLoading && <FullPageLoader visible={isLoading} />}
      </AppWrapper>

      <Dialog
        visible={modalVisible}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm"
        modal
        footer={modalFooter}
        onHide={hideDeleteModal}
      >
        <div
          className="confirmation-content"
          style={{ marginTop: 20, display: "flex", alignItems: "center" }}
        >
          <i
            className="pi pi-exclamation-triangle mr-3"
            style={{ fontSize: "2rem", marginRight: 15, color: "#e65061" }}
          />
          <p>
            Are you sure you want to delete this parent?
            <br />
            <em>
              <strong style={{ color: colors.danger }}>
                PS: This operation can not be undone.
              </strong>
            </em>
          </p>
        </div>
      </Dialog>

      <Dialog
        visible={isUploadAvatarModal}
        style={{ width: "32rem", zIndex: 999999 }}
        breakpoints={{ "960px": "75vw", "641px": "90vw" }}
        header="Confirm Action"
        modal
        onHide={() => {
          setPreviewAvatar("");
          setIsUploadAvatarModal(false);
        }}
      >
        <div
          className="confirmation-content"
          style={{
            marginTop: 20,
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <div className="avatar-preview-box mb-20">
            {!empty(previewAvatar) ? (
              <img src={previewAvatar} alt="" />
            ) : (
              <FaCloudUploadAlt size={80} />
            )}
          </div>
          {<span>Select image to upload</span>}

          <div className="flex flex-center w-100pc col-g-12">
            <ButtonIcon
              height={40}
              marginTop={1}
              color={colors.tomato}
              backgroundColor={colors.lightgray}
              width={170}
              fontSize={22}
              borderColor={colors.lightgray}
              buttonText="Select Avatar"
              iconMarginRight={8}
              icon={<FaImage />}
              fontWeight="bold"
              onClick={handleImageFilePickUp}
            />
            {previewAvatar ? (
              <ButtonIcon
                height={40}
                marginTop={1}
                color={colors.primary}
                backgroundColor={colors.lightgray}
                width={180}
                fontSize={22}
                borderColor={colors.lightgray}
                buttonText="Update Avatar"
                iconMarginRight={8}
                icon={<FaCloudUploadAlt />}
                fontWeight="bold"
                onClick={() => submitAvatar()}
              />
            ) : null}
            {/* Hidden file input */}
            <input
              type="file"
              ref={fileInputRef}
              onChange={(e) => handleFileUpload(e, setPreviewAvatar)}
              style={{ display: "none" }}
              accept="image/*"
            />
          </div>
        </div>
      </Dialog>
      <Toast ref={toastTR} style={{ zIndex: 99999 }} position="bottom-left" />
    </>
  );
};

export default ParentProfile;
